import { RewardInput } from '@app/graphql'

export enum TournamentSteps {
  DETAILS = 'details',
  MATCHES = 'matches'
}

export enum CreationStep {
  CONTENT = 0,
  EVENT = 1,
  REWARD = 2,
  PREVIEW = 3,
}

export enum CompetitionRewardDisplayMode {
  MANUAL = 'MANUAL',
  COVER_IMAGE = 'COVER_IMAGE',
}

export type TournamentFormData =  {
  tournamentName: string
  startDate: Date
  endDate: Date
  reward: RewardInput[]
  market: { name: string; id: string | null }
  bookie: { name: string; id: string | null }
  numberOfPlaces: string
  backgroundImage: File | null
  cta: string
  tournamentDescription: string
  eventIds: string[]
}

export type Match = {
  id: string
  title: string
}

export type Market = {
  id: string
  name: string
}

export type Bookie = {
  id: string
  name: string
}

export type Event = {
  id: string
  competitors: any[]
}

export const FILE_TYPES = [ 'JPG', 'PNG', 'GIF', 'JPEG' ]
